import { Body1, Button, Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle, Radio, RadioGroup, Spinner, Subtitle1, Title1, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Payment32Regular,
  ArrowLeftFilled,
  DismissRegular,
  } from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';

// import { PayPalScriptProvider, PayPalButtons, BraintreePayPalButtons } from "@paypal/react-paypal-js";

import { useLocation, useHistory } from 'react-router-dom';

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

  const useStyles = makeStyles({
    root: {
        display: "flex",
        // backgroundColor: "#fff",
        flexDirection: "column",
        width: "850px",
    },
    detail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        // ...shorthands.overflow("hidden"),
        display: "flex",
        // height: "650px",
        backgroundColor: "#fff",
        ...shorthands.gap("20px"),
        justifyContent: "center",
        ...shorthands.padding("20px"),
        ...shorthands.border("2px", "solid", "#ccc"),
        boxShadow: tokens.shadow8,
        ...shorthands.borderRadius("10px"),
    },
    userDetail: {
        ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "505px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px"),
    },
    paymentDetail: {
        ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "319px",
        ...shorthands.padding("10px", "20px"),
        ...shorthands.borderRadius("10px")
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      rowGap: "10px"
    },
    flex: {
      display: "flex", 
      justifyContent: "end", 
      alignItems: "center",
      ...shorthands.gap("20px"),
    },
    flexLeft: {
      display: "flex", 
      justifyContent: "start", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    contentSpacing: {
      display: "flex", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: 'auto',
      height: 'auto',
      boxSizing: 'border-box',
      '> *': {
        textOverflow: 'ellipsis',
      },
      '> :not(:first-child)': {
        marginTop: '0px',
      },
      '> *:not(.ms-StackItem)': {
        flexShrink: 1,
      },
    },
    vertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    verticalCenter: {
      display: 'flex',
      alignItems: "center"
    },
    fullWidth: {
      width: "100%"
    },
    spaceBetween: {
      justifyContent: "space-between"
    },
    verticalSpaceBetween: {
      alignContent: "space-between"
    },
    columnGap: {
      ...shorthands.gap("0px", "10px"),
    },
    rowGap: {
      ...shorthands.gap("10px", "0px"),
    },
    horizontalCenter: {
      display: "flex",
      justifyContent: "center"
    }
  });

//   const slideDown = keyframes`
//   from {
//     transform: translateY(-100%);
//   }
//   to {
//     transform: translateY(0);
//   }
// `;

// const AnimatedRow = styled.tr`
//   border: 1px solid black;
//   padding: 8px;
//   animation: ${slideDown} 0.5s ease;
// `;

function makeDecimalNumber(num) {
  return num.toLocaleString(undefined, {
     maximumFractionDigits: 2,
     minimumFractionDigits: 2,
   })
 }

const API_URL = process.env.REACT_APP_API_URL;

const PaymentChannels = () => {
    const styles = useStyles();

    const location = useLocation();
    const history = useHistory();

    const [backUrl, setBackUrl] = useState('/payments');

    const { t } = useTranslation();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [selectedPaymentChannel, setSelectedPaymentChannel] = useState("")

    const companyId = sessionStorage.getItem('companyId') || '';

    const [packageId, setPackageId] = useState("")
    const [fileId, setFileId] = useState("")
    const [total, setTotal] = useState(0)

    const [manual, setManual] = useState(true)
    const [loading, setLoading] = useState(true)

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

    const [messageBar, setMessageBar] = useState({ show: false, type: "", title: "", message: "", actionText: "", action: null})

    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    const [getUnpaidSuccess, setGetUnpaidSuccess] = useState(true)

    useEffect(() => {
      if (getCompanyDetailSuccess && getUnpaidSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess, getUnpaidSuccess])

    function fetchCompanyData() {
      console.log('userEffect retrieve company and accounts data!');
  
      const urlPath = window.location.pathname;
      console.log('Body urlPath: ', urlPath);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                console.log(response);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    
                    console.log(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")))
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    sessionStorage.setItem("companyId", response.data[0].id);
  
                    _cid = response.data[0].id
                  }
  
                  axios
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                        if (companiesDetailsResponse.data) {
                          console.log('companiesDetailsResponse: ', companiesDetailsResponse);
                          if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                            setManual(true)
                            setLoading(false)

                            // history.push({
                            //   pathname: '/etax/documents/all',
                            //   state: {},
                            // });
                          } else {
                            setManual(false)
                          }
                        }

                        setGetCompanyDetailSuccess(true)
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
  
            axios
            .get(API_URL + '/accounts', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                
                if (response.data) {
                  console.log(response);
                }

              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });
    }

    function getUnpaidStatements() {
      const documentsListEndpoint = `${API_URL}/documents/billings?status=open`
    
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const statementResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        console.log("statementResponse", statementResponse)

        const documents = statementResponse.data.data?.documents || []

        if (documents.length) {
          const unpaidDocuments = documents.filter(_doc => {
            if (_doc.data.billing?.disabledCancel) {
              return true
            }
  
            const isoTimeNow = new Date().toISOString()
            if (isoTimeNow > _doc.data.dueDate) {
              return false
            }
  
            return true
          })

          if (unpaidDocuments.length && !location.state.fileId) {
            history.push('/payments')
          }
        }

        setGetUnpaidSuccess(true)

        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getUnpaidStatements error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    async function initLocationProps(_location) {
      const locationProps = _location.state

      console.log("locationProps", locationProps)
      if (locationProps) {
        if (locationProps.backUrl === '/packages' || locationProps.backUrl === "/packages/add-ons") {
          setBackUrl(locationProps.backUrl)


          const _packageId = locationProps.packageId
          const _total = locationProps.total

          setPackageId(_packageId)
          setTotal(_total)

          // setLoading(false)
        } else {
          const _fileId = locationProps.fileId
          const _total = locationProps.total

          setFileId(_fileId)
          setTotal(_total)
          // setLoading(false)
          // getBills(statementList)
        }

        if (locationProps.error) {
          setMessageBar({ show: true, type: "error", title: "", message: "", actionText: "", action: null})
        }
      } else {
        history.push({
          pathname: backUrl,
          state: {},
        });
      }
      
    }

    useEffect(() => {
      fetchCompanyData()
      initLocationProps(location)
      getUnpaidStatements()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleBuyPackage(_packageId, _selectedPaymentChannel) {
      console.log("handleBuyAddOnPackage running")
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {

        const createBillingEndpoint = `${API_URL}/documents/billings`

        const createBillingResponse = await axios.post(createBillingEndpoint, { packageId: _packageId }, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    }
                                  })

        console.log("billingAddOnResponse", createBillingResponse)

        // const createBillingResponse = { data: {
        //                                 "fileName": "1732164261619",
        //                                 "fileSize": 309159,
        //                                 "createdTime": "2024-11-21T04:44:21.000Z",
        //                                 "createdBy": "ed1984ad-9c56-460f-8391-a768ebabef3f",
        //                                 "xmlFileName": null,
        //                                 "xmlFileSize": 0,
        //                                 "fileId": "67e41573-b81a-46f1-bc43-579c30821bd8"
        //                               }}

        if (createBillingResponse.data.fileId) {
          handlePaymentChannel(createBillingResponse.data.fileId, _selectedPaymentChannel)
        }
        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("handleBuyAddOnPackage error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    const openFilePdf = (fileId) => {
      setLoading(true);

      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const documentsListEndpoint = `${API_URL}/documents/billings?status=open`
    
        const statementResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        console.log("statementResponse", statementResponse)

        const documents = statementResponse.data.data?.documents || []

        const item = documents.find(_doc => _doc.id === fileId)

        if (item) {
          history.push({
            pathname: '/billings/pdf/view',
            state: {
              item: {
                number: item.data.number,
                signature: item.signatures[0].certificateName,
                digitalSign: item.digitalSign,
                key: item.id,
                createdTimeValue: item.createdTime,
                type: item.type,
                fileExtension: item.data.fileExtension,
              },
              backUrl: "/payments",
            },
          });
        }
      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
      });
    };

    function handlePaymentChannel(_fileId, _selectedPaymentChannel) {
      if (_selectedPaymentChannel === "promptPay") {
        history.push({
          pathname: '/payments/channels/viewQR',
          state: { 
            channel: _selectedPaymentChannel,
            fileId: _fileId,
            total: total
          },
        });
      } else if (_selectedPaymentChannel === "billingNote") {
        openFilePdf(_fileId)
      } else {
        instance
          .acquireTokenSilent({ ...silentRequest, account: account })
          .then(async (tokenResponse) => {
            const response = await axios.post(`${API_URL}/payments/2c2p/web-pay`, 
                                {
                                  fileId: _fileId,
                                  bankCode: _selectedPaymentChannel
                                }, 
                                {
                                  headers: {
                                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                                    'cid': companyId,
                                    'Content-Type': 'application/json',
                                  },
                                })
  
            console.log("response payment", response)
            const _webPaymentUrl = response.data.data
  
            window.location.href = _webPaymentUrl;
  
          }).catch((error) => {
            //Acquire token silent failure, and send an interactive request
            console.log(error);
  
            setMessageBar({ show: true, type: "error", title: "", message: "", actionText: "", action: null})
            setLoading(false)
            // handlePaymentFail()
          });
      }
    }

    function handleGotoPayment(_selectedPaymentChannel) {
      handleCloseConfirmDialog()
      setLoading(true)

      if (backUrl === "/packages" || backUrl === "/packages/add-ons") {
        handleBuyPackage(packageId, _selectedPaymentChannel)
      } else {
        handlePaymentChannel(fileId, _selectedPaymentChannel)
      }
    }

    function handleGoback(e) {
      history.push({
        pathname: backUrl,
        state: {},
      });
    }

    function handleOpenConfirmDialog() {
      setOpenConfirmDialog(true)
    }

    function handleCloseConfirmDialog() {
      setOpenConfirmDialog(false)
    }

    function handleCloseMessageBar() {
      setMessageBar({ show: false, type: "", title: "", message: "", actionText: "", action: null})
    }

    return <div style={homeStyles}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`paymentChannels.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t(`paymentChannels.thisPageCannotReach`)}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t(`paymentChannels.homepage`)}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
        {messageBar.show ? (
          <>
            <MessageBar intent={messageBar.type}>
              <MessageBarBody>
                <MessageBarTitle>{t(`paymentChannels.anErrorOccurred`)}</MessageBarTitle>
                {t(`paymentChannels.pleaseTryAgain`)}
              </MessageBarBody>
              <MessageBarActions
                containerAction={
                  <Button
                    aria-label="dismiss"
                    appearance="transparent"
                    icon={<DismissRegular />}
                    onClick={handleCloseMessageBar}
                  />
                }
              >
                {/* <Button appearance='primary' onClick={() => messageBar.action()}>ทดสอบ</Button> */}
              </MessageBarActions>
            </MessageBar>
            <br />
          </>
        ) : null}
          <div style={{ display: "flex", justifyContent: "center"}}>
              <div className={styles.root}>
                  <Title1 as='h1'>
                    <div style={{ display: "flex", flexDirection: "row"}}>
                      <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                        <Payment32Regular />
                      </div>
                      <div className={styles.verticalCenter}>
                        <div>
                          {t(`paymentChannels.paymentChannelsHeader`)}

                        </div>
                      </div>
                    </div>
                  </Title1>
                  <div className={styles.detail}>
                    <div className={mergeClasses(styles.vertical, styles.fullWidth, styles.columnGap)}>
                      <div onClick={() => {
                          if (!loading) {
                            handleGoback()
                          }
                        }} 
                        style={{ display: "flex", flexDirection: "row"}}
                      >
                        <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                          <ArrowLeftFilled />
                        </div>
                        <div className={styles.verticalCenter}>
                          <Body1>{t(`paymentChannels.back`)}</Body1>
                        </div>
                      </div>
                      {loading ? (
                        <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                          <Spinner labelPosition="below" label={t(`paymentChannels.loading`)} />

                        </div>
                      ) : (
                        <>
                          <div className={styles.horizontalCenter}>
                            <label>{t(`paymentChannels.amountDue`)}</label>

                          </div>
                          <div className={mergeClasses(styles.fullWidth, styles.rowGap)} style={{ border: "1px solid #0f6cbd", borderRadius: 10, height: 30, display: "flex", flexDirection: "row", padding: "10px 0px 10px 0px", alignItems: "center", justifyContent: "center"}}>
                            <Title1 style={{ color: "#0f6cbd"}}>{makeDecimalNumber(total)}</Title1>
                            <label>{t(`paymentChannels.baht`)}</label>
                          </div>
                          <h2>{t(`paymentChannels.paymentChannels`)}</h2>
    
                              <Field label={
                                <div className={styles.fullWidth} style={{ backgroundColor: "rgb(238, 238, 238)" }}>
                                  <Body1>{t(`paymentChannels.qrCode`)}</Body1>
                                </div>
                              }>
                                <RadioGroup onChange={(e, data) => setSelectedPaymentChannel(data.value)}>
                                  <Radio value="promptPay" label={t(`paymentChannels.promtPay`)} />
                                  <div className={styles.fullWidth} style={{ backgroundColor: "rgb(238, 238, 238)" }}>
                                    <Body1>{t(`paymentChannels.internetBanking`)}</Body1>
                                  </div>
                                  <Radio value="BBL" label={t(`paymentChannels.bangkokBank`)} />
                                  <Radio value="KTB" label={t(`paymentChannels.krungThaiBank`)} />
                                  <Radio value="BAY" label={t(`paymentChannels.bankOfAyudhya`)} />
                                  <Radio value="KBANK" label={t(`paymentChannels.kasikornBank`)} />
                                  <Radio value="SCB" label={t(`paymentChannels.siamCommercialBank`)} />
                                  <Radio value="TMB" label={t(`paymentChannels.thanachartBank`)} />
                                  <Radio value="UOB" label={t(`paymentChannels.unitedOverseasBank`)} />
                                  <Radio value="GSB" label={t(`paymentChannels.governmentSavingsBank`)} />
                                  <div className={styles.fullWidth} style={{ backgroundColor: "rgb(238, 238, 238)" }}>
                                    <Body1>{t(`paymentChannels.billing`)}</Body1>
                                  </div>
                                  <Radio value="billingNote" label={t(`paymentChannels.billingNote`)} />
                                </RadioGroup>
                              </Field>
                              <div>
                                <div className={styles.horizontalCenter}>
                                  <Button appearance="primary" size='large' disabled={!selectedPaymentChannel} onClick={() => handleOpenConfirmDialog()}>
                                    {t(`paymentChannels.pay`)}
                                  </Button>

                                  </div>
                              </div>
                        </>
                      )}
                    </div>
                  </div>
              </div>

          </div>
          <Dialog open={openConfirmDialog} onOpenChange={handleCloseConfirmDialog}>
            <DialogSurface style={{ width: 300 }}>
              <DialogBody>
                <DialogTitle style={{ textAlign: "center" }}>{t(`paymentChannels.confirmPayingBillingDialogTitle`)}</DialogTitle>
                <DialogContent className={styles.dialogContent} style={{ textAlign: "center" }}>
                  {t(`paymentChannels.confirmPayingBillingDialogContent`)}
                  <div style={{ display: "flex", justifyContent: "center", width: "100%", gap: 10}}>
                    <Button type="submit" appearance="primary" onClick={() => handleGotoPayment(selectedPaymentChannel)}>
                      {t(`paymentChannels.confirm`)}
                    </Button>
                    <Button appearance="secondary" onClick={handleCloseConfirmDialog}>
                      {t(`paymentChannels.cancel`)}
                    </Button>
                  </div>
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
        </>
      )}
    </div>
};

export default PaymentChannels;
